import React from 'react'

function Learndetails() {
    return (
        <div>Learndetails</div>
    )
}

export default Learndetails